<template>
  <div class="giftTpye">
    <div class="getTpye" v-if="$store.state.common.giftGetType">
      <span class="title">{{
        $store.state.common.giftGetType == 1 ? "领取成功!" : "已领取!"
      }}</span>
      <div class="middle">
        <div class="code_row">
          <div class="code_row_l">
            <span class="code_text">兑换码：</span>
            <span class="code">{{ $store.state.common.giftCode }}</span>
          </div>
          <div class="code_row_r" @click="copy" @mouseenter="copy()" ref="btn" :data-clipboard-text="$store.state.common.giftCode">
            <span>复制</span>
          </div>
        </div>
        <div class="tip">
          <img src="../assets/img/explain.png" alt="" />
          <span>每个兑换码仅可成功兑换一次哦！</span>
        </div>
      </div>
      <div class="botBtn">
        <div class="btn" @click="closeGiftType">关闭</div>
        <div class="btn" @click="toGame">进入游戏</div>
      </div>
    </div>
    <div class="explain" v-else-if="$store.state.common.giftExplain">
      <span class="title">礼包使用说明</span>
      <div class="explain_row">
        <span>{{ $store.state.common.giftExplainText }}</span>
      </div>
      <div class="btn" @click="closeExplain">
        <span>知道啦</span>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  name: "giftTpye",
  props: ["giftCode"],
  data() {
    return {

     };
  },
  created() {},
  mounted() {
  },
  methods: {
    closeGiftType() {
      this.$store.dispatch("GiftGetTypeFun", 0);
      this.$store.dispatch("GiftExplainFun", false);
    },
    closeExplain() {
      this.$store.dispatch("GiftExplainFun", false);
      this.$store.dispatch("GiftGetTypeFun", 0);
    },
    toGame() {
      window.location.href=this.$store.state.common.giftGameUrl
    },
    copy() {
      let btn = this.$refs.btn;
      var clipboard = new Clipboard(btn);
      clipboard.on("success", ()=> {
        this.$toast.text("已复制");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.giftTpye {
  @include flex_box(column, space-between, stretch);
  font-size: 12px;

  margin-bottom: 1rem;
  .getTpye,
  .explain {
    width: 6.8rem;
    height: 4.8rem;
    padding: 0.4rem 0;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #fff;
    @include flex_box(column, space-between, center);
  }
  .title {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
  }
  .middle {
    @include flex_box(column, center, center);
  }
  .code_row {
    @include flex_box(row, center, stretch);
    height: 0.82rem;
  }
  .code_row_l,
  .code_row_r {
    @include flex_box(row, center, center);
  }
  .code_row_l {
    background-color: #ededed;
    width: 4.52rem;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    color: #000000;
  }
  .code_text {
    font-size: 14px;
    font-weight: bold;
  }
  .code {
    padding-top: 0.08rem;
  }
  .code_row_r {
    background-color: #bebebe;
    width: 1.76rem;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    color: #fff;
  }
  .tip {
    margin-top: 0.16rem;
    @include flex_box(row, center, center);
    color: #f05b5b;
    img {
      width: 0.36rem;
      height: auto;
    }
    span {
      transform: scale(0.9);
      transform-origin: center center;
    }
  }
  .botBtn,
  .btn {
    @include flex_box(row, center, center);
  }
  .botBtn {
    margin-top: 0.3rem;
  }
  .btn {
    width: 2.2rem;
    height: 0.6rem;
    background-color: #ff913a;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    margin: 0 0.6rem;
  }
  .explain {
    height: 6.4rem;
    color: #000000;
    font-size: 12px;
    padding: 0.4rem 0.4rem 0.5rem;
    .btn {
      width: 5.32rem;
      height: 0.8rem;
      margin-top: 0.4rem;
    }
  }
  .explain_row {
    flex: 1;
    overflow-y: scroll;
    @include flex_box(column, center, stretch);
    font-weight: bold;
    span {
      white-space: pre-wrap;
      text-align: left;
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/giftTpye.vue